(function () {
    'use strict';

    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtCachedInformationProxy', PmtCachedInformationProxy);

    PmtCachedInformationProxy.$inject = ['$http', '$q'];
    function PmtCachedInformationProxy($http, $q) {
        var service = {
            getCachedInformation: getCachedInformation
        };

        return service;

        ////////////////
        function getCachedInformation(uri, checkinId) {

            return $http.get(uri + checkinId + '/cached').then(getCachedInformationComplete)['catch'](getCachedInformationFailed);

            function getCachedInformationComplete(response) {
                return response.data;
            }

            function getCachedInformationFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();